import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'app-newemp',
  templateUrl: './newemp.page.html',
  styleUrls: ['./newemp.page.scss'],
})
export class NewempPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

}
